import React, {useEffect, FC} from "react"

import Flex from "@irati/ui/src/Flex"
import Loading from "@irati/ui/src/Loading"
import {hangPromise} from "@irati/utils/promise"
import assertionService from "@irati/auth/services/assertions"
import {GenerateAssertionProvider, VivupBenefitType} from "@irati/types"
import useAuth from "@irati/auth/helpers/auth/useAuth"
import {Http403, Http404} from "@irati/ui/src/Errors"
import {RouteComponentProps} from "react-router-dom"

const allowedRegions = ["UK"]
const eapAllowedRegions = ["UK", "IRE"]

interface Props extends RouteComponentProps<{product?: string}> {}

const Saml: FC<Props> = (props) => {
  const {product} = props.match.params
  const {user} = useAuth()
  const isEapProduct = !product || product === "eap"
  const isCtwProduct = product === "ctw"
  const hasEapPermission = isEapProduct && eapAllowedRegions.includes(user?.regionId!)
  const hasCtwPermission = isCtwProduct && allowedRegions.includes(user?.regionId!)
  const userCanSeePage = hasEapPermission || hasCtwPermission
  const benefitType = getBenefitType(product) || VivupBenefitType.BenefitTypeYourCareWellbeingPlatform

  useEffect(() => {
    if (!userCanSeePage || !benefitType) {
      return
    }

    assertionService
      .generateAssertion({
        provider: GenerateAssertionProvider.ServiceProviderVivup,
        metadata: {
          vivup: {benefitType}
        }
      })
      .then(({response, acs}) => {
        // Create a new form element
        const form = document.createElement("form")
        form.method = "POST"
        form.action = acs

        // Create input field
        const responseInput = document.createElement("input")
        responseInput.type = "hidden"
        responseInput.name = "SAMLResponse"
        responseInput.value = response

        // Append inputs to form
        form.appendChild(responseInput)

        // Append form to body
        document.body.appendChild(form)

        // Submit the form
        form.submit()

        // Remove form from the DOM
        document.body.removeChild(form)
      })
  }, [userCanSeePage, benefitType])

  return (
    <>
      {userCanSeePage ? <Loading load={hangPromise()} /> : <Flex justifyContent="center">{!benefitType ? <Http404 /> : <Http403 />}</Flex>}
    </>
  )
}

export default Saml

const getBenefitType = (product?: string) => {
  switch (product) {
    case "eap":
      return VivupBenefitType.BenefitTypeYourCareWellbeingPlatform
    case "ctw":
      return VivupBenefitType.BenefitTypeCycleToWork
    default: {
      const benefitType = `BENEFIT_TYPE_${product?.toUpperCase().replaceAll("-", "_")}`

      if (Object.values(VivupBenefitType).includes(benefitType as VivupBenefitType)) {
        return benefitType
      }

      return
    }
  }
}
